<template>
<div>
	<div class="orders-product mt-3">
		<div
			class="title-products font-size mb-1"
			:style="`color:${globalColors.primary}`"
		>{{orderState}} - NRO DE ORDEN {{orderNumber}}</div>
		<div class="d-flex space-between wrap">
			<div>
				<p class="text-regular">Precio Total: <span class="text-bold font-size">PEN {{orderTotal}}</span></p>
			</div>
			<div>
				<p class="text-regular">Fecha de la Orden: <span class="text-bold font-size">{{orderDate}}</span></p>
			</div>
			<div>
				<p class="text-regular">Estado: <span class="text-bold font-size">{{orderPaymentStateName}}</span></p>
			</div>
		</div>
		<div class="border-bottom">
			<p class="text-regular">Direccion de envío : <span class="text-bold font-size">{{orderWarehouseAddress}}</span></p>
		</div>
	</div>
	<div class="voucher-section">
	  	<p
	  		class="title-deposit-data"
			:style="`color:${globalColors.primary}`"
		>DATOS DE DEPOSITO</p>
		<div class="d-flex space-between">
			<div class="wrapper-list-item">
				<el-form :model="deposit">
					<el-form-item class="mb-2">
						<el-input
						class="qtc-input"
						v-model="deposit.number"
						placeholder="Nro de Deposito"
						></el-input>
					</el-form-item>
					<el-form-item class="mb-2">
						<el-input
							class="qtc-input"
							v-model="deposit.voucher"
							placeholder="Foto de Voucher"
						>
						</el-input>
						<div>
							<input hidden ref="upLoadAvatar" type="file" :accept="allowedFiles" @change="upLoadAvatar"/>
							<div
								class="mask d-flex align-center justify-center"
								:style="`background-color:${globalColors.primary}`"
								@click="maskFn"
							>
								<img :src="loadAvatarBtn" alt="" width="22" height="20">
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<img
				v-if="deposit.voucher"
				:src="deposit.voucher"
				alt="contanciar de pago"
				class="voucher-image"
			>
		</div>
		<div class="flex-95 d-flex align-center justify-center">
			<button 
				type="button" 
				class="btn-deposit" 
				@click="goTo('orders')"
				:style="`background-color:${globalColors.secondary}`"
			>Cancelar</button>
			<button 
				:disabled="!(deposit.voucher && deposit.number)"
				type="button" 
				class="btn-deposit"
				:style="`background-color:${globalColors.primary}`"
				@click="updateVoucher"
			>Guardar</button>
		</div>
 	</div>
</div> 
</template>

<script>
import { mapGetters } from 'vuex';
import lib from '@/helpers/lib';

const { getDeeper } = lib;

function orderHandler(order) {
	const { additionalInfo } = order;
	if (additionalInfo) {
		this.deposit.number = additionalInfo.depositNumber;
		this.deposit.voucher = additionalInfo.urlVoucher;
	}
}

function orderWarehouseAddress() {
	return getDeeper('warehouseAddress')(this.order);
}

async function updateVoucher() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const body = {
		depositNumber: this.deposit.number,
		urlVoucher: this.deposit.voucher,
	};
	const id = this.$route.params.id;
	try {
		await this.$httpJapi.patch(`orders/${id}/voucher`, body, { headers });
		this.$message.success({ message: 'Datos enviado exitosamente', showClose: true });
		this.goTo('orders');
	} catch (error) {
		this.$message({
			message: 'Error',
			showClose: true,
			type: 'error',
		});
	}
}

function orderPaymentStateName() {
	return getDeeper('paymentStateName')(this.order);
}

function orderState() {
	return getDeeper('orderState.name')(this.order);
}

function orderNumber() {
	return getDeeper('number')(this.order);
}

function upLoadAvatar() {
	const reader = new FileReader();
	const file = this.$refs.upLoadAvatar.files[0];
	reader.onload = (evt) => {
		const fileData = {
			name: file.name.replace(/\s/g, '-'),
			base64data: evt.target.result,
		};
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		this.$httpUpLoad.post('upload-files', fileData, { headers })
			.then((response) => {
				this.deposit.voucher = response.data.Location;
			})
			.catch(() => {
				this.$message({
					message: 'No es posible cargar ese archivo',
					showClose: true,
					type: 'error',
				});
			});
	};
	reader.readAsDataURL(file);
}

function goTo(name) {
	this.$router.push({ name });
}

function maskFn() {
	this.$refs.upLoadAvatar.click();
}

function orderTotal() {
	return getDeeper('total')(this.order);
}

function orderDate() {
	const date = getDeeper('createdAt')(this.order);
	const day = new Date(date).getDay();
	const month = new Date(date).getMonth() + 1;
	const year = new Date(date).getFullYear();
	return `${day}-${month}-${year}`;
}

function data() {
	return {
		allowedFiles: '.svg,.png,.jpg,.jpeg,.svg',
		loadAvatarBtn: '/static/img/icons/camera.svg',
		deposit: {
			number: null,
			voucher: null,
		},
	};
}

export default {
	data,
	name: 'deposit-data',
	computed: {
		orderDate,
		orderNumber,
		orderPaymentStateName,
		orderState,
		orderTotal,
		orderWarehouseAddress,
		...mapGetters([
			'getUserInfo',
			'token',
		]),
	},
	methods: {
		goTo,
		maskFn,
		orderHandler,
		upLoadAvatar,
		updateVoucher,
	},
	props: {
		order: {
			default: () => {},
			type: Object,
		},
	},
	watch: {
		order: {
			deep: true,
			handler: orderHandler,
		},
	},
};
</script>

<style lang="scss" scoped>
.title-deposit-data {
	font-family: font(avenirBold);
	font-size: size(normal);
	margin: 0 0 3.5rem 1rem;
}

.btn-deposit {
	border: none;
	color: color(white);
	font-family: font(avenirDemi);
	font-size: size(large);
	margin: 1rem;
	padding: 1.5rem 3rem;
}
.btn-deposit:disabled {
	cursor: not-allowed;
	opacity: 0.3;
}

.wrapper-list-item {
	flex: 1 1 50%;
	padding: 0 2rem;
}

.mask {
	border-top-right-radius: 0.4rem;
	border-bottom-right-radius: 0.4rem;
	bottom: 0rem;
	cursor: pointer;
	height: 4.6rem;
	position: absolute;
	right: 0;
	width: 5.6rem;
}

.orders-product {
	font-size: size(medium);
	padding: 0rem 5rem;
}

.title-products {
	font-weight: bold;
}

.font-size {
	font-size: size(medium);
}

.border-bottom {
	border-bottom: 0.2em solid color(border-grey);
}

.text-bold {
	font-weight: bold;
}

.text-regular {
	font-weight: normal;
}

.voucher-section {
	padding: 2rem 4rem;
}

.voucher-image {
	flex: 1 1 10%;
	padding: 0 2rem;
	max-width: 22rem;
	object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// deposit-data.vue?06179128